<template>
  <div class="gadget-wrapper" ref="gadgetWrapper">
    <transition name="fade">
      <app-start v-if="moduleState.start"></app-start>
    </transition>

    <my-games v-if="moduleState.storysList"></my-games>

    <story-pattern v-if="moduleState.pattern"></story-pattern>

    <creation-type v-if="moduleState.creationType"></creation-type>

    <edit-story v-if="moduleState.editStory"></edit-story>

    <create-role v-if="moduleState.createRole"></create-role>

    <role-material v-if="moduleState.rolePicMaterial"></role-material>

    <chapter-set v-if="moduleState.chapterset"></chapter-set>

    <change-chapter v-if="moduleState.changeChapter"></change-chapter>

    <role-list v-if="moduleState.roleList"></role-list>

    <edit-story-role v-if="moduleState.editStoryRole"></edit-story-role>

    <image-preview v-if="moduleState.imageLibraryPreview"></image-preview>

    <div v-if="landscape" class="landscape-popup">
      <div class="inner">
        <img src="../static/image/rotate.png">
        <p>竖屏体验更佳</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import store from './store/store';
  import start from './components/start';
  import myGamesList from './components/my_games';
  import Preview from './components/image_preview';
  import CreationType from './components/creation_type_main';
  import StoryPattern from './components/pattern';
  import EditStory from './components/edit_story';
  import EditStoryRole from './components/edit_story_role';
  import CreateRole from './components/create_role';
  import RoleMaterial from './components/material';
  import ChaptersSet from './components/chapters_set';
  import roleList from './components/role_list';
  import ChangeChapterSet from './components/change_chapters_set';
  import configText from './config/ConfigText';

  export default {
    name: 'index',
    components: {
      'app-start': start,
      'my-games': myGamesList,
      'image-preview': Preview,
      'story-pattern': StoryPattern,
      'creation-type': CreationType,
      'edit-story': EditStory,
      'edit-story-role': EditStoryRole,
      'create-role': CreateRole,
      'role-material': RoleMaterial,
      'chapter-set': ChaptersSet,
      'role-list': roleList,
      'change-chapter': ChangeChapterSet
    },
    computed: {
      ...mapState(['moduleState'])
    },
    store,
    data() {
      return {
        landscape: false
      }
    },
    mounted() {
      var _that = this;

      // 判断横竖屏
      var utils = {
        debounce: function (func, delay) {
          var _timer = null;

          clearTimeout(_timer);
          _timer = setTimeout(function () {
            func();
          }, delay);
        }
      };

      function detectOrient() {
        var storage = localStorage;
        var data = storage.getItem(location.protocol + '-qc-recordOrientX');
        var cw = document.documentElement.clientWidth;
        var _Width = 0, _Height = 0, sw, sh;

        if (!data) {
          sw = window.screen.width;
          sh = window.screen.height;

          _Width = sw < sh ? sw : sh;
          _Height = sw >= sh ? sw : sh;
          storage.setItem('qc-recordOrientX', _Width + ',' + _Height);
        } else {
          var str = data.split(',');
          _Width = str[0];
          _Height = str[1];
        }
        if (cw == _Width) {
          // 竖屏
          _that.landscape = false;
          return;
        }
        if (cw == _Height) {
          // 横屏
          _that.landscape = true;
          return;
        }
      };

      window.addEventListener('resize', function () {
        utils.debounce(detectOrient, 300)
      });

      detectOrient();
    }
  }
</script>

<style>
  @import "./style/base/common.css";
</style>



// WEBPACK FOOTER //
// src/index.vue